module.exports = "/images/d39771871f51c7849693d1d8885e0623.svg";